import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './modules/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { FormMaterialComponent } from './form-material.component';

import './utils/prototypes';
import { AmountDirective } from './directives/amount.directive';
import { SafePipe } from './pipe/safe.pipe';

const COMPONENTS = [
  FormMaterialComponent
];

@NgModule({
  declarations: [...COMPONENTS, AmountDirective, SafePipe],
  imports: [
    CommonModule,
    ReactiveFormsModule, FormsModule,
    FileUploadModule,
    FlexLayoutModule,
    HttpClientModule,
    MaterialModule
  ],
  exports: [COMPONENTS],
  entryComponents: [COMPONENTS]
})
export class FormMaterialModule { }
